import { Component, ElementRef, ViewChild } from '@angular/core';
import { DialogService } from '@ansys-internal/awf-angular/shared';
import {
  ActionContributionsService,
  WorkspaceTab,
} from '@ansys-internal/awf-angular/contributions';
import { ImportLibraryAssetComponent } from '../../../dialogs/import-library-asset/import-library-asset.component';
import { UnitsComponent } from '../../../dialogs/units/units.component';
import { ConceptService } from '../../../../shared/services/concept.service';
import { MenuBarComponent } from '@ansys-internal/awc-angular/menus';
import { Icons } from '@ansys-internal/awc-angular/icons';
import { ModalSize } from '@ansys-internal/awc-angular/modals';
import { NgIf } from '@angular/common';
import { TabSelectAction } from '@ansys-internal/awf-angular/workspace';
import { Injector } from '@angular/core';

@Component({
    selector: 'app-concept-navigation-tools',
    templateUrl: './concept-navigation-tools.component.html',
    styleUrls: ['./concept-navigation-tools.component.scss'],
    imports: [MenuBarComponent, NgIf]
})
export class ConceptNavigationToolsComponent {
  @ViewChild('focusButton', { static: false }) focusButton!: ElementRef;
  protected display: boolean = false;
  protected show: boolean = true;
  protected id: string = 'ExampleMenuBar';
  protected items = [
    {
      id: 'units',
      text: 'Units',
      icon: {
        src: 'https://s2.svgbox.net/materialui.svg?ic=emoji_symbols',
      },
      execute: (): void => {
        this.openUnits();
      },
    },
    {
      id: 'library',
      text: 'Library',
      icon: {
        icon: Icons.LEGO,
      },
      execute: (): void => {
        this.openLibrary();
      },
    },
  ];

  constructor(
    private dialogService: DialogService,
    private conceptService: ConceptService,
    private actions: ActionContributionsService,
    private injector: Injector
  ) {
    this.actions.get(TabSelectAction).subscribe((tab?: WorkspaceTab) => {
      this.show = tab?.path === 'concept';
    });
  }

  private openUnits(): void {
    this.dialogService.open(UnitsComponent, {
      size: ModalSize.FULL_SCREEN,
      title: 'Units',
    });
  }

  private openLibrary(): void {
    this.dialogService.open(ImportLibraryAssetComponent, {
      size: ModalSize.FULL_SCREEN,
      title: 'Library',
      injector: this.injector,
    });
  }
}
